import { CalenderIcon } from 'assests/GmsIcons';
import React, { forwardRef } from 'react';

type TCustomInputProps = {
    value?: string;
    onClick?: () => void;
}

const CustomInput = forwardRef<HTMLButtonElement, TCustomInputProps>(({ value, onClick }, ref) => (
    <button type="button" className="tw-flex tw-items-center tw-p-2 border tw-rounded" onClick={onClick} ref={ref}>
        <span className="tw-mr-2">{value}</span>
        <CalenderIcon />
    </button>
));

CustomInput.displayName = 'CustomInput';

export default CustomInput;
